<app-programtitle title="Find whether a given year is leap year"></app-programtitle>

<p> Write a program to find whether a given year is leap  year or not. A leap year is any year that's divisible by 4.</p>

<p> The % operator is used to get the reminder. </p>

<app-editor code="{{program}}"> </app-editor>
